module.exports = __webpack_public_path__ + "static/media/clear.70566a6.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/clear.wav
// module id = 150
// module chunks = 1